import { render, staticRenderFns } from "./SpecBulkPanel.vue?vue&type=template&id=5981d101&scoped=true&lang=pug&"
import script from "./SpecBulkPanel.vue?vue&type=script&lang=js&"
export * from "./SpecBulkPanel.vue?vue&type=script&lang=js&"
import style0 from "./SpecBulkPanel.vue?vue&type=style&index=0&id=5981d101&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5981d101",
  null
  
)

export default component.exports